import PostMortemEmail from "components/postmortem-email/postmortem-email";

export default PostMortemEmail;
